import OptimizationStore from "modules/optimization/store/OptimizationStore";
import ProductConstants from "constants/ProductConstants";
import utils from "modules/optimization/components/products/income-builder/utils";
import pgiUtils from "modules/optimization/components/products/premium-guaranteed-income/utils";
import * as Constants from "constants/Constants";
import gisUtils from "modules/optimization/components/products/GIS/utils"
import gfsUtils from "modules/optimization/components/products/guaranteed-flexi-star/utils"
import fdpUtils from "modules/optimization/components/products/flexi-dream-plan/utils"
import aisUtils from "modules/optimization/components/products/assured-income-star/utils"
import fgsUtils from "modules/optimization/components/products/flexi-goal-secure/utils"

function calculate_input_values(data) {
  /**
   * Parameters required to show the content in tab
   * outputAmt = "2272200"
      yearlyOutputAmount = "151480"
      totalOutputYear = "15"
      totalOutputYearSuffixLabel = "years"
      additionalOutputAmt = ""
      inputAmount = amount
      yearlyInputAmount = "100000"
      totalInputYear = "10"
      totalInputYearSuffixLabel = "years"
   */
  let productName = data.product_name;
  return fetchYouPayYouGetPrice(productName, data);

  let inputFormatString = "";
  let outFormatString = "";
  let prodcutName = data.product_name;
  let inputPremium = OptimizationStore.fetchProductPrice(prodcutName, data.firstYearResponse);
  let outputPremium = OptimizationStore.fetchProductPrice(prodcutName, data.firstYearResponse);
  let totalOutputYearSuffixLabel = "years";
  let totalInputYearSuffixLabel = "years";
  let investment_target = data.investment_target;
  let premium_paying_term = data.bi_request.PR_PPT;
  let input_mode = data.bi_request.INPUT_MODE;

  inputFormatString = getFormatedData(input_mode);

  outFormatString = getFormatedData(input_mode);
  outputPremium = 300000; //TODO this is hard coded value, should get changed

  return {
    inputAmount: inputPremium,
    inputStr: inputFormatString,
    yearlyInputAmount: inputPremium,
    totalInputYear: premium_paying_term,
    totalInputYearSuffixLabel: totalInputYearSuffixLabel,
    yearlyOutputAmount: outputPremium,
    outputStr: outFormatString,
    outputAmt: outputPremium,
    totalOutputYear: premium_paying_term,
    totalOutputYearSuffixLabel: totalOutputYearSuffixLabel,
    yearlyOutputAmountBold: yearlyOutputAmountBold
  };
}

function fetchYouPayYouGetPrice(productName, productDetails) {
  console.log("$%$%$%$%$%$%$%$%$%");
  console.log("fetchYouPayYouGetPrice productName :::: ", productName);
  console.log("fetchYouPayYouGetPrice productDetails :::: ", productDetails);
  console.log("$%$%$%$%$%$%$%$%$%");
  let inputAmount = 0; // You pay total amount
  let yearlyInputAmount = 0; // yearly input amount in you pay
  let inputStr = ""; // string just after the yearly input amount
  let totalInputYear = 0; // number of input years/months/etc
  let totalInputYearSuffixLabel = ""; //suffix text to be shown after number of input years
  let outputAmt = 0; // You get total amount
  let totalOutputAmtSuffixLabel = "";
  let yearlyOutputAmount = 0; // yearly output amount in you get
  let outputStr = ""; // string just after the yearly input amount
  let totalOutputYear = 0; // number of output years/months/etc
  let totalOutputYearSuffixLabel = ""; //suffix text to be shown after number of output years
  let belowOutputYearSuffixLabel = ""; //below suffix text
  let additionalOutputAmt = ""; // additional output amount if any
  let outputNote = "";
  let yearlyOutputAmountBold = true
  let showPayoutPeriodMsg = false
  let payoutPeriodMsg = ""
  let onlyShowBelowOutputYearSuffixLabel = false
  let startingOutPutLabel = ""

  if (!productDetails?.isValidationExist) {
    payoutPeriodMsg = `After a period of ${productDetails?.bi_request?.PR_PT} years`

    switch (productName) {
      case ProductConstants.FOREVER_PENSION:
      case ProductConstants.FOREVER_PENSION_IMMEDIATE_ANNUITY:
      case ProductConstants.FOREVER_PENSION_DEFERRED_ANNUITY:
      case ProductConstants.POS_FOREVER_PENSION:
        let targetAmountForeverPension = Math.round(productDetails?.biResponseCompleteData.find(item => item.MODAL_ANNUITY_PAYOUT !== 0).MODAL_ANNUITY_PAYOUT)
        if (Number(productDetails?.bi_request?.AnnuityMode) === 21) {
          outputAmt = Math.round(targetAmountForeverPension)
        } else if (Number(productDetails?.bi_request?.AnnuityMode) === 22) {
          outputAmt = Math.round(targetAmountForeverPension * 2)
        } else if (Number(productDetails?.bi_request?.AnnuityMode) === 23) {
          outputAmt = Math.round(targetAmountForeverPension * 4)
        } else {
          outputAmt = Math.round(targetAmountForeverPension * 12)
        }
        inputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        yearlyInputAmount = "";
        inputStr = "";
        totalInputYear = "";
        totalInputYearSuffixLabel = "";
        outputAmt = outputAmt;
        totalOutputAmtSuffixLabel = "per annum" + " " + "for Lifetime";
        yearlyOutputAmount = "";
        outputStr = outputStr;
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.EASY_PENSION:
        let annualPremium = productDetails?.firstYearResponse?.MODAL_PREM_DISP;
        if (productDetails?.bi_request?.INPUT_MODE === 1 || productDetails?.bi_request?.INPUT_MODE === 5) {
          annualPremium = annualPremium;
        } else if (productDetails?.bi_request?.INPUT_MODE === 2) {
          annualPremium = annualPremium * 2;
        } else if (productDetails?.bi_request?.INPUT_MODE === 3) {
          annualPremium = annualPremium * 4;
        } else if (productDetails?.bi_request?.INPUT_MODE === 4) {
          annualPremium = annualPremium * 12;
        }

        inputAmount = Math.round(annualPremium * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(annualPremium);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(productDetails?.parsedResponse?.PENSION_AMT_TVB);
        totalOutputAmtSuffixLabel = "per annum for Lifetime";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.SARAL_PENSION:
        if (Number(productDetails?.bi_request?.AnnuityMode) === 8) {
          outputStr = "per annum";
          outputAmt = Math.round(productDetails?.firstYearResponse?.SB_G)
        } else if (Number(productDetails?.bi_request?.AnnuityMode) === 9) {
          outputStr = "per half year";
          outputAmt = Math.round(Math.round(productDetails?.firstYearResponse?.SB_G) * 2)
        } else if (Number(productDetails?.bi_request?.AnnuityMode) === 10) {
          outputStr = "per quarter";
          outputAmt = Math.round(Math.round(productDetails?.firstYearResponse?.SB_G) * 4)
        } else {
          outputStr = "per month";
          outputAmt = Math.round(Math.round(productDetails?.firstYearResponse?.SB_G) * 12)
        }
        inputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        yearlyInputAmount = "";
        inputStr = "";
        totalInputYear = "";
        totalInputYearSuffixLabel = "";
        outputAmt = outputAmt;
        totalOutputAmtSuffixLabel = "per annum" + " " + "for Lifetime";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.PREMIER_GUARANTEED_INCOME_LUMPSUM:
      case ProductConstants.PREMIER_GUARANTEED_INCOME_LUMPSUM_FIB:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          inputStr = "per annum";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          inputStr = "per half year";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          inputStr = "per quarter";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          inputStr = "per month";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12;
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";

        outputAmt = Math.round(productDetails?.parsedResponse?.MATURITY_BEN);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true
        break;

      case ProductConstants.PREMIER_GUARANTEED_SHORT_TERM_INCOME:
      case ProductConstants.PREMIER_GUARANTEED_SHORT_TERM_INCOME_FIB:
        let outputFrequencyLabel = "";
        let inputFrequencyLabel = "";
        let incomeBenefitPayoutFrequencyValue = 1;
        let incomePayoutDuration = pgiUtils.fetchIncomePayoutDuration(Number(productDetails?.bi_request?.IncomeBenefitPayoutDuration))

        if (Number(productDetails?.bi_request?.IncomeBenefitPayoutFrequency) === 1) {
          incomeBenefitPayoutFrequencyValue = 1;
        } else if (Number(productDetails?.bi_request?.IncomeBenefitPayoutFrequency) === 2) {
          incomeBenefitPayoutFrequencyValue = 2;
        } else if (Number(productDetails?.bi_request?.IncomeBenefitPayoutFrequency) === 3) {
          incomeBenefitPayoutFrequencyValue = 4;
        } else if (Number(productDetails?.bi_request?.IncomeBenefitPayoutFrequency) === 4) {
          incomeBenefitPayoutFrequencyValue = 12;
        }
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          inputFrequencyLabel = "per annum";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          inputFrequencyLabel = "per half year";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          inputFrequencyLabel = "per quarter";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          inputFrequencyLabel = "per month";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12;
        }
        productDetails?.biResponseCompleteData?.forEach((item) => {
          if (Number(item.INCOME_BEN_PAY_OUT) != 0 && yearlyOutputAmount === 0) {
            yearlyOutputAmount = item.INCOME_BEN_PAY_OUT;
          }
          outputAmt += Math.round(item.INCOME_BEN_PAY_OUT);
        });
        // productDetails?.biResponseCompleteData?.forEach((item) => {
        //   outputAmt += Math.round(item.INCOME_BEN_PAY_OUT);
        // });
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        // totalInputYearSuffixLabel = `years + ₹ ${Math.round(productDetails?.firstYearResponse?.DEATH_BENEFIT || 0)}`;
        totalInputYearSuffixLabel = "years";
        outputAmt = outputAmt;
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = Math.round(yearlyOutputAmount);
        outputStr = "per annum";
        totalOutputYear = `for ${incomePayoutDuration}`;
        totalOutputYearSuffixLabel = "years";
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.PREMIER_GUARANTEED_LONG_TERM_INCOME:
      case ProductConstants.PREMIER_GUARANTEED_LONG_TERM_INCOME_FIB:
        let incomePayoutDurationLTI = pgiUtils.fetchIncomePayoutDuration(Number(productDetails?.bi_request?.IncomeBenefitPayoutDuration))
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          inputStr = "per annum";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          inputStr = "per half year";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          inputStr = "per quarter";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          inputStr = "per month";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12;
        }
        productDetails?.biResponseCompleteData?.forEach((item) => {
          if (Number(item.INCOME_BEN_PAY_OUT) != 0 && yearlyOutputAmount === 0) {
            yearlyOutputAmount = item.INCOME_BEN_PAY_OUT;
          }
          outputAmt += Math.round(item.INCOME_BEN_PAY_OUT);
        });
        // productDetails?.biResponseCompleteData?.forEach((item) => {
        //   outputAmt += Math.round(item.INCOME_BEN_PAY_OUT);
        // });
        let lumpsumBenefit = Number(productDetails?.bi_request?.LumpsumBenefit) !== 7

        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = `years`;
        outputAmt = Math.round(outputAmt + Math.round(productDetails?.parsedResponse?.MATURITY_BEN));
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = Math.round(yearlyOutputAmount);
        outputStr = "per annum";
        totalOutputYear = `for ${incomePayoutDurationLTI}`;
        totalOutputYearSuffixLabel = lumpsumBenefit ? `years + ₹ ${Math.round(productDetails?.parsedResponse?.MATURITY_BEN || 0).toLocaleString('en-IN')}` : 'years';
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.PREMIER_GUARANTEED_RETIREMENT_INCOME:
        let incomePayoutDurationRI = pgiUtils.fetchIncomePayoutDuration(Number(productDetails?.bi_request?.IncomeBenefitPayoutDuration))
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          inputStr = "per annum";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          inputStr = "per half year";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          inputStr = "per quarter";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4;

        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          inputStr = "per month";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12;
        }
        productDetails?.biResponseCompleteData?.forEach((item) => {
          if (Number(item.INCOME_BEN_PAY_OUT) != 0 && yearlyOutputAmount === 0) yearlyOutputAmount = item.INCOME_BEN_PAY_OUT;
        });
        productDetails?.biResponseCompleteData?.forEach((item) => {
          outputAmt += Math.round(item.INCOME_BEN_PAY_OUT);
        });
        if (Number(productDetails?.bi_request?.IncomeBenefitPayoutType) === 6) belowOutputYearSuffixLabel = "Increasing Annually";
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = `years`;

        outputAmt = Math.round(outputAmt + Math.round(productDetails?.parsedResponse?.MATURITY_BEN));
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = Math.round(yearlyOutputAmount);
        outputStr = "per annum";
        totalOutputYear = `for ${incomePayoutDurationRI}`;
        totalOutputYearSuffixLabel = `years + ₹ ${Math.round(productDetails?.parsedResponse?.MATURITY_BEN).toLocaleString('en-IN') || 0}`;
        belowOutputYearSuffixLabel = belowOutputYearSuffixLabel;
        break;

      case ProductConstants.PREMIER_GUARANTEED_STAR:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          // inputStr = "per annum";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          // inputStr = "per half year";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          // inputStr = "per quarter";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4;

        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          // inputStr = "per month";
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12;
        }

        productDetails?.biResponseCompleteData?.forEach((item) => {
          if (Number(item.INCOME_BEN_PAY_OUT) != 0 && yearlyOutputAmount === 0) yearlyOutputAmount = item.INCOME_BEN_PAY_OUT;
        });
        productDetails?.biResponseCompleteData?.forEach((item) => {
          outputAmt += Math.round(item.INCOME_BEN_PAY_OUT);
        });

        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount)
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = `years`;

        outputAmt = Math.round(outputAmt) + Math.round(productDetails?.parsedResponse?.MATURITY_BEN);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = Math.round(yearlyOutputAmount);
        outputStr = "per annum";
        totalOutputYear = `for 5 years  ${productDetails?.bi_request?.LumpsumBenefit === '1' ? ', Increases by 5% in every 5 years + ₹' + Math.round(productDetails?.parsedResponse?.MATURITY_BEN) : ''}`;
        belowOutputYearSuffixLabel = ''

        break;

      case ProductConstants.PREMIER_GUARANTEED_STAR_PRO:

        let totalyouPay = 0
        let totalYouGet = 0
      
        productDetails?.biResponseCompleteData?.forEach((item) => {
          totalYouGet = totalYouGet + Math.round(item.SURV_BEN) + Math.round(item.MAT_BEN) + Math.round(item.EXIST_CUST_ECS_BENEFIT)
        });

        
        totalyouPay = Math.round(productDetails?.firstYearResponse?.PREM_DISP) * Number(productDetails?.bi_request?.PR_PPT);

        inputAmount = totalyouPay;
        yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.PREM_DISP)
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = `years`;

        outputAmt = totalYouGet;
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "per annum";
        totalOutputYear = ""
        belowOutputYearSuffixLabel = "Refer Cashflow Table for Details";

        break;

      case ProductConstants.ACTIVE_INCOME_PLAN:
      case ProductConstants.THREE_GENERATION_PLAN_ACTIVE_INCOME_PLAN:
      case ProductConstants.ACTIVE_INCOME_PLAN_WITH_FIB:
      case ProductConstants.WHOLE_LIFE_ACTIVE_INCOME_ACTIVE_INCOME_PLAN:
      case ProductConstants.RETIRE_BEFIKER_ACTIVE_INCOME_PLAN:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        let targetAmount = 0;
        let totalTargetAmount = 0;
        let earlyIncomeTargetAmt = 0;
        let totalEarlyIncomeTargetAmount = 0;
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          if (Number(productDetails?.bi_request?.PR_PPT) === index) targetAmount = Math.round(item.TOTAL_SB_G_BS_2);
          if (Number(productDetails?.bi_request?.PR_PPT) <= index) totalTargetAmount += Math.round(item.TOTAL_SB_G_BS_2);
        });
        if (Number(productDetails?.bi_request?.IncomeOption) === 3) {
          earlyIncomeTargetAmt = Math.round(productDetails?.biResponseCompleteData?.[1].TOTAL_SB_G_BS_2);
          yearlyOutputAmount = earlyIncomeTargetAmt;
          if (earlyIncomeTargetAmt < targetAmount) {
            yearlyOutputAmountBold = false
          }
          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            // if (Number(productDetails?.bi_request?.PR_PPT) - 1 >= index && index !== 0) {
            totalEarlyIncomeTargetAmount += Math.round(item.TOTAL_SB_G_BS_2);

            // }
          });
          totalOutputYear = Number(productDetails?.bi_request?.PR_PPT) - 1;
          totalOutputYearSuffixLabel = <span>years + ₹ <ins className='font-weight-medium'>{Math.round(targetAmount).toLocaleString('en-IN')}</ins> per annum for {Number(productDetails?.bi_request?.PR_PT.split("-")[0]) - Number(productDetails?.bi_request?.LI_ENTRY_AGE) - Number(productDetails?.bi_request?.PR_PPT)} years + ₹ {Math.round(productDetails?.parsedResponse?.TOTAL_MB_G_BS_2).toLocaleString('en-IN')}</span>

          // totalOutputYearSuffixLabel = `years + ₹ ${targetAmount} per annum for ${99 - Number(productDetails?.bi_request?.LI_ENTRY_AGE) - Number(productDetails?.bi_request?.PR_PPT)
          //   } years + ₹ ${Math.round(productDetails?.parsedResponse?.TOTAL_MB_G_BS_2)}`;
          outputAmt = Math.round(totalEarlyIncomeTargetAmount) + Math.round(productDetails?.parsedResponse?.TOTAL_MB_G_BS_2);
        } else {
          yearlyOutputAmount = targetAmount;
          totalOutputYear = Number(productDetails?.bi_request?.PR_PT.split("-")[0]) - Number(productDetails?.bi_request?.LI_ENTRY_AGE) - Number(productDetails?.bi_request?.PR_PPT);
          totalOutputYearSuffixLabel = `years + ₹ ${Math.round(productDetails?.parsedResponse?.TOTAL_MB_G_BS_2).toLocaleString('en-IN')}`;
          outputAmt = Math.round(totalTargetAmount) + Math.round(productDetails?.parsedResponse?.TOTAL_MB_G_BS_2);
        }
        if (Number(productDetails?.bi_request?.GuaranteedIncomeType) === 6) belowOutputYearSuffixLabel = "Increasing Annually";
        inputAmount = inputAmount;
        yearlyInputAmount = yearlyInputAmount;
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = outputAmt;
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = yearlyOutputAmount;
        outputStr = "per annum for";
        totalOutputYear = totalOutputYear;
        totalOutputYearSuffixLabel = totalOutputYearSuffixLabel;
        belowOutputYearSuffixLabel = belowOutputYearSuffixLabel;
        yearlyOutputAmountBold = yearlyOutputAmountBold
        break;

      case ProductConstants.CASH_FLOW_PROTECTION_PLUS:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        let cFTargetAmount = 0;
        let cFTotalTargetAmount = 0;
        let cFSurvivalBenefit = 0;
        let cFMaturityBenefit = 0;
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          if (Number(productDetails?.bi_request?.PR_PPT) + 1 === index) cFTargetAmount = item.TOTAL_SB_BS_2;
          // if (Number(productDetails?.bi_request?.PR_PPT) + 1 <= index) cFTotalTargetAmount += Math.round(item.TOTAL_SB_BS_2);
          cFTotalTargetAmount += Math.round(item.TOTAL_SB_BS_2);
          if (Number(productDetails?.bi_request?.PR_PPT) - 1 === index) cFSurvivalBenefit = Math.round(item.TOTAL_SB_BS_2);
        });
        cFMaturityBenefit = Math.round(productDetails?.parsedResponse?.SB_G);
        cFTotalTargetAmount = cFTotalTargetAmount + cFMaturityBenefit;
        totalOutputYear = 100 - Number(productDetails?.bi_request?.LI_ENTRY_AGE) - Number(productDetails?.bi_request?.PR_PPT);

        inputAmount = inputAmount;
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(cFTotalTargetAmount);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = Math.round(cFTargetAmount);
        outputStr = "per annum";
        totalOutputYear = `for ${totalOutputYear}`;
        totalOutputYearSuffixLabel = `years + ₹ ${Math.round(cFSurvivalBenefit).toLocaleString('en-IN')} + ₹ ${Math.round(cFMaturityBenefit).toLocaleString('en-IN')}`;
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.INCOME_BUILDER:
      case ProductConstants.SECURED_INCOME_OPTION_INCOME_BUILDER:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(Math.round(productDetails?.firstYearResponse?.MODAL_PREM));
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(Math.round(productDetails?.firstYearResponse?.MODAL_PREM)) * 2;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(Math.round(productDetails?.firstYearResponse?.MODAL_PREM)) * 4;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(Math.round(productDetails?.firstYearResponse?.MODAL_PREM)) * 12;
        }

        inputAmount = Math.round(yearlyInputAmount) * Number(productDetails?.bi_request?.PR_PPT);
        productDetails?.biResponseCompleteData?.forEach((item) => {
          outputAmt += Math.round(item.INCOME_DISPLAY);
          if (Number(item.PAYOUT_PERIOD) == 1) {
            yearlyOutputAmount = Math.round(item.INCOME_DISPLAY);
          }
        });
        let payoutPeriodList = utils.getPayoutPeriodList();
        let payoutPeriodValue = payoutPeriodList.find((item) => Number(item.id) == Number(productDetails?.bi_request?.PayoutPeriodInYears));

        if (Number(productDetails?.bi_request?.MaturityBenefitOption) === 13) {
          totalOutputYear = `for ${payoutPeriodValue?.label || productDetails?.bi_request?.PayoutPeriodInYears}`;
          totalOutputYearSuffixLabel = "years";
        } else {
          outputAmt = 0
          let maturityBenefit = 0;
          productDetails?.biResponseCompleteData?.forEach((item) => {
            if (Number(item.INCOME_DISPLAY) != 0 && maturityBenefit === 0) {
              maturityBenefit = Math.round(item.INCOME_DISPLAY);
            }
            if (Number(item.PAYOUT_PERIOD) >= 1) {
              outputAmt += Math.round(item.MODAL_INCOME);
            }
          });
          outputAmt += (Math.round(productDetails?.parsedResponse?.INCOME_DISPLAY) - maturityBenefit)
          totalOutputYear = `for ${Number(payoutPeriodValue?.label || productDetails?.bi_request?.PayoutPeriodInYears)}`;
          totalOutputYearSuffixLabel = `years + ₹ ${(Math.round(productDetails?.parsedResponse?.INCOME_DISPLAY) - maturityBenefit).toLocaleString('en-IN')}`;
        }
        inputAmount = inputAmount;
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = 'per annum';
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";

        outputAmt = Math.round(outputAmt);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = yearlyOutputAmount;
        outputStr = "per annum";
        totalOutputYear = totalOutputYear;
        totalOutputYearSuffixLabel = totalOutputYearSuffixLabel;
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.GUARANTEED_SAVINGS_STAR_LUMPSUM:
      case ProductConstants.GUARANTEED_SAVINGS_STAR_LUMPSUM_FIB:
      case ProductConstants.POS_GUARANTEED_SAVINGS_STAR:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }

        inputAmount = Math.round(yearlyInputAmount) * Number(productDetails?.bi_request?.PR_PPT);
        if (Number(productDetails?.bi_request?.MaturityBenefitOption) === 1) {
          outputAmt = Math.round(productDetails?.parsedResponse?.MB_G);
        } else {
          productDetails?.biResponseCompleteData?.forEach((item) => {
            if (Number(item.MB_G) != 0 && yearlyOutputAmount === 0) {
              yearlyOutputAmount = Math.round(item.MB_G);
            }
            outputAmt = outputAmt + Number(item.MB_G);
          });
        }
        inputAmount = inputAmount;
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = outputAmt;
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = yearlyOutputAmount;
        outputStr = "per annum";
        totalOutputYear = "for 5 years";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true
        break;

      case ProductConstants.GUARANTEED_SAVINGS_STAR_INCOME:
      case ProductConstants.GUARANTEED_SAVINGS_STAR_INCOME_FIB:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(Number(productDetails?.firstYearResponse?.MODAL_PREM));
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(Number(productDetails?.firstYearResponse?.MODAL_PREM)) * 2;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(Number(productDetails?.firstYearResponse?.MODAL_PREM)) * 4;
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(Number(productDetails?.firstYearResponse?.MODAL_PREM)) * 12;
        }

        inputAmount = Math.round(yearlyInputAmount) * Number(productDetails?.bi_request?.PR_PPT);
        if (Number(productDetails?.bi_request?.MaturityBenefitOption) === 1) {
          outputAmt = Math.round(productDetails?.parsedResponse?.MB_G);
        } else {
          productDetails?.biResponseCompleteData?.forEach((item) => {
            if (Number(item.MB_G) != 0 && yearlyOutputAmount === 0) {
              yearlyOutputAmount = Math.round(item.MB_G);
            }
            outputAmt = outputAmt + Number(item.MB_G);
          });
        }
        inputAmount = inputAmount;
        yearlyInputAmount = yearlyInputAmount;
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = outputAmt;
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = yearlyOutputAmount;
        outputStr = "per annum";
        totalOutputYear = "for 5 years";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.GUARANTEED_INCOME_STAR_BETTER_INNINGS:
      case ProductConstants.GUARANTEED_INCOME_STAR_BETTER_INNINGS_FIB:
      case ProductConstants.GUARANTEED_INCOME_STAR_CASHBACK_GUARANTEED:
      case ProductConstants.GUARANTEED_INCOME_STAR_CASHBACK_GUARANTEED_FIB:
      case ProductConstants.GUARANTEED_INCOME_STAR:
      case ProductConstants.GUARANTEED_INCOME_STAR_FIB:
      case ProductConstants.GUARANTEED_INCOME_STAR_MILESTONES_GUARANTEED:
      case ProductConstants.POS_GUARANTEED_INCOME_STAR_CASHBACK_GUARANTEED:
      case ProductConstants.POS_GUARANTEED_INCOME_STAR:
      case ProductConstants.POS_GUARANTEED_INCOME_STAR_BETTER_INNINGS:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        let maturityBenefit = 0;
        let lumpsumBenefitSelected = Number(productDetails?.bi_request?.LumpsumBenefit) == 22;
        let incomeStartOption = gisUtils.fetchIncomeStartOptionValue(productDetails?.bi_request?.IncomeStartOption);

        // For Large Income Benefit
        outputStr = "per annum";
        if (Number(productDetails?.bi_request?.IncomeOption) === 6) {
          // Income Benefit Pay-Out (first payout)
          productDetails?.biResponseCompleteData?.forEach((item) => {
            if (Number(item.INCOME_BENEFIT_FINAL) != 0 && yearlyOutputAmount === 0) yearlyOutputAmount = Math.round(item.INCOME_BENEFIT_FINAL);
            outputAmt += Math.round(item.INCOME_BENEFIT_FINAL);
          });
          totalOutputYear = "on every 5th year";

          // Maturity Benefit
          if (lumpsumBenefitSelected) {
            maturityBenefit = Math.round(productDetails?.parsedResponse?.MB_G);
            outputAmt += maturityBenefit
          }

          // Payout Period
          let payoutPeriod = productDetails?.biResponseCompleteData?.length - Number(productDetails?.bi_request?.PR_PPT);
          if (lumpsumBenefitSelected) {
            totalOutputYearSuffixLabel = `for ${payoutPeriod} years + ₹ ${Math.round(maturityBenefit).toLocaleString('en-IN')}`;
          } else {
            totalOutputYearSuffixLabel = `for ${payoutPeriod} years`;
          }
          if (Number(productDetails?.bi_request?.IncomeBenefitPayoutType) == 31) belowOutputYearSuffixLabel = "Increasing every time";
        }

        // For Flexible Income Benefit
        else {
          yearlyOutputAmount = productDetails?.biResponseCompleteData && Math.round(productDetails?.biResponseCompleteData[(Number(productDetails?.bi_request?.PR_PPT)) - 1].INCOME_BENEFIT_FINAL);

          outputAmt = 0
          productDetails?.biResponseCompleteData?.forEach((item) => {
            if (Number(item.INCOME_BENEFIT_FINAL) != 0) outputAmt += Math.round(item.INCOME_BENEFIT_FINAL);
          });


          // Maturity Benefit

          if (lumpsumBenefitSelected) maturityBenefit = Math.round(productDetails?.parsedResponse?.MB_G);

          outputAmt = outputAmt + Math.round(productDetails?.parsedResponse?.MB_G)

          let modalInvestmentIncomePostPPT = productDetails?.biResponseCompleteData && Math.round(productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + 1]?.INCOME_BENEFIT_FINAL);
          let payoutPeriodPostPPT = 0;
          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            if (Number(productDetails?.bi_request?.PR_PPT) <= index && Math.round(item.INCOME_BENEFIT_FINAL) !== 0) payoutPeriodPostPPT += 1;
          });

          if (Number(incomeStartOption.label) > Number(productDetails?.bi_request?.PR_PPT)) {
            yearlyOutputAmount = productDetails?.biResponseCompleteData && Math.round(productDetails?.biResponseCompleteData[Number(incomeStartOption.label) - 1].INCOME_BENEFIT_FINAL);

            totalOutputYearSuffixLabel = <span>{gisUtils.fetchIncomeDuration(productDetails?.bi_request?.IncomeDuration)} years {lumpsumBenefitSelected && '+ ₹ ' + Math.round(maturityBenefit).toLocaleString('en-IN')}</span>

            // `${gisUtils.fetchIncomeDuration(productDetails?.bi_request?.IncomeDuration)} years ${lumpsumBenefitSelected && '+ ₹ ' + maturityBenefit}}`;
          } else {
            let totalYear = 0
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              if (Number(productDetails?.bi_request?.PR_PPT) > index && Math.round(item.INCOME_BENEFIT_FINAL) !== 0) totalYear += 1;
            });
            if (yearlyOutputAmount < modalInvestmentIncomePostPPT) {
              yearlyOutputAmountBold = false
            }

            totalOutputYear = `${totalYear} years`;
            totalOutputYearSuffixLabel = <span>{totalOutputYear} + ₹ <ins className='font-weight-medium'>{Math.round(modalInvestmentIncomePostPPT).toLocaleString('en-IN')}</ins> {outputStr} for {payoutPeriodPostPPT} years {lumpsumBenefitSelected && '+ ₹ ' + Math.round(maturityBenefit).toLocaleString('en-IN')}</span>

            // totalOutputYearSuffixLabel = ` ${totalOutputYear} + ₹ ${modalInvestmentIncomePostPPT} ${outputStr} for  ${payoutPeriodPostPPT} years`;
          }

          // if (lumpsumBenefitSelected) {
          //   totalOutputYearSuffixLabel = totalOutputYearSuffixLabel + ` + ₹ ${maturityBenefit}`;
          // } 
          belowOutputYearSuffixLabel = "";
        }

        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = yearlyInputAmount;
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";

        outputAmt = outputAmt;
        // totalOutputAmtSuffixLabel = `${totalOutputYearSuffixLabel}`;
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = yearlyOutputAmount;
        outputStr = "per annum";
        totalOutputYear = Number(productDetails?.bi_request?.IncomeOption) === 6 ? 'every 5 years' : ' for';
        // totalOutputYear = totalOutputYear || ' for';
        totalOutputYearSuffixLabel = totalOutputYearSuffixLabel;
        belowOutputYearSuffixLabel = belowOutputYearSuffixLabel;
        break;


      case ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS:
      case ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS_FIB:
      case ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED:
      case ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED_FIB:
      case ProductConstants.GUARANTEED_FLEX_STAR:
      case ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_FIB:
      case ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_MILESTONES_GUARANTEED:
      case ProductConstants.POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED:
      case ProductConstants.POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR:
      case ProductConstants.POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS:
        yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.ANN_PREM_YEARLY)

        let incomeStartYearGFS = gfsUtils.IncomeBenefitPayoutStartYear(productDetails?.bi_request?.IncomeBenefitPayoutStartYear)
        let incomeDuration = gfsUtils.fetchIncomeDuration(productDetails?.bi_request?.IncomeDuration)
        let PT_Value = Math.round(productDetails?.parsedResponse?.POLICYTERM)

        let totaloutputAmtGFS = 0
        let outputAmtGFS = 0
        let totalOutputYearGFS = 0
        let outputAmtGFS2 = 0
        let outputAmtGFS3 = 0
        let outputAmtGFS4 = 0
        if (Number(productDetails?.bi_request?.PlanOption) === 1) {
          outputAmtGFS = Math.round(productDetails?.parsedResponse?.MB_G)
          totaloutputAmtGFS = Math.round(productDetails?.parsedResponse?.MB_G)
          startingOutPutLabel = "Get"
          outputStr = "at the end of"
          totalOutputYear = Number(productDetails?.bi_request?.PR_PT)
          totalOutputYearSuffixLabel = <span>Years</span>
        } else if (Number(productDetails?.bi_request?.PlanOption) === 2) {

          if (Number(productDetails?.bi_request?.PremiumOffsetOption) === 49) {
            let offsetValue = gfsUtils.PremiumOffsetOptionIncomeStartYear(productDetails?.bi_request?.PremiumOffsetOptionIncomeStartYear)
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              totaloutputAmtGFS = totaloutputAmtGFS + Math.round(item?.PRE_INC_BEN_SOY) + Math.round(item?.PRE_INC_BEN_EOY) + Math.round(item?.BAL_INC_EOY) + Math.round(item?.MB_G)
              outputAmtGFS = productDetails?.biResponseCompleteData[offsetValue + 1]?.BAL_INC_EOY
              outputAmtGFS2 = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + 3]?.BAL_INC_EOY
              outputAmtGFS3 = Math.round(productDetails?.parsedResponse?.MB_G)
              totalOutputYearGFS = Number(productDetails?.bi_request?.PR_PPT) - Number(offsetValue) + 1
              totalOutputYear = totalOutputYearGFS
              startingOutPutLabel = "Get "
              outputStr = "per annum for";
              totalOutputYearSuffixLabel = <span> Years + <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS2)).toLocaleString('en-IN')}</ins> per annum for 30 years +  ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS3)).toLocaleString('en-IN')}</ins> at the end of {Number(PT_Value)} Year</span>
            });

          } else if (Number(productDetails?.bi_request?.IncomeOption) === 9 && Number(productDetails?.bi_request?.Cashback) === 36) {
            //! Income Type =  Level && Cashback == No
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              totaloutputAmtGFS = totaloutputAmtGFS + Math.round(item?.PRE_INC_BEN_SOY) + Math.round(item?.PRE_INC_BEN_EOY) + Math.round(item?.BAL_INC_EOY) + Math.round(item?.MB_G)
              //! Timing = Start of Year
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 37) outputAmtGFS = Math.round(item?.PRE_INC_BEN_SOY);
              //! Timing = End of Year
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 38) outputAmtGFS = Math.round(item?.PRE_INC_BEN_EOY);

            });
            outputAmtGFS2 = Math.round(productDetails?.parsedResponse?.MB_G)
            totalOutputYearGFS = Number(PT_Value) - Number(incomeStartYearGFS?.label) + 1
            totalOutputYear = totalOutputYearGFS
            startingOutPutLabel = "Get "
            outputStr = "per year for";
            totalOutputYearSuffixLabel = <span> Years + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS2)).toLocaleString('en-IN')}</ins> at the end of {Number(PT_Value)} Years</span>
          } else if (Number(productDetails?.bi_request?.IncomeOption) === 9 && Number(productDetails?.bi_request?.Cashback) === 35) {
            //! Income Type =  Level && Cashback == Yes
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              totaloutputAmtGFS = totaloutputAmtGFS + Math.round(item?.PRE_INC_BEN_SOY) + Math.round(item?.PRE_INC_BEN_EOY) + Math.round(item?.BAL_INC_EOY) + Math.round(item?.MB_G)
              outputAmtGFS = Math.round(productDetails?.firstYearResponse?.PRE_INC_BEN_SOY)
              //! Timing = Start of Year
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 37) outputAmtGFS2 = Math.round(item?.PRE_INC_BEN_SOY);
              //! Timing = End of Year
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 38) outputAmtGFS2 = Math.round(item?.PRE_INC_BEN_EOY);
              //! label 3
              // if (Number(PT_Value) === index) outputAmtGFS3 = item?.MB_G
            });

            //! label 3
            outputAmtGFS3 = Math.round(productDetails?.parsedResponse?.MB_G)
            totalOutputYearGFS = Number(PT_Value) - Number(incomeStartYearGFS?.label) + 1
            startingOutPutLabel = "Get Cashback of "
            outputStr = "";
            totalOutputYear = ""
            totalOutputYearSuffixLabel = <span> + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS2)).toLocaleString('en-IN')}</ins> for {totalOutputYearGFS} Years + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS3)).toLocaleString('en-IN')}</ins> at the end of {Number(PT_Value)} Years</span>
          } else if (Number(productDetails?.bi_request?.IncomeOption) === 45 && Number(productDetails?.bi_request?.Cashback) === 36) {
            //! Income Type =  Increaing && Cashback == No
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              totaloutputAmtGFS = totaloutputAmtGFS + Math.round(item?.PRE_INC_BEN_SOY) + Math.round(item?.PRE_INC_BEN_EOY) + Math.round(item?.BAL_INC_EOY) + Math.round(item?.MB_G)
              //! Timing = Start of Year label 1
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 37) outputAmtGFS = Math.round(item?.PRE_INC_BEN_SOY);
              //! Timing = End of Year label 1
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 38) outputAmtGFS = Math.round(item?.PRE_INC_BEN_EOY);

              //! Timing = Start of Year label 2
              if (Number(productDetails?.bi_request?.PR_PPT) === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 37) outputAmtGFS2 = Math.round(item?.PRE_INC_BEN_SOY);
              //! Timing = End of Year label 2
              if (Number(productDetails?.bi_request?.PR_PPT) === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 38) outputAmtGFS2 = Math.round(item?.PRE_INC_BEN_EOY);
              //!  label 3
              // if (Number(productDetails?.bi_request?.PR_PT) === index) outputAmtGFS3 = item?.MB_G
            });
            //! label 3
            outputAmtGFS3 = Math.round(productDetails?.parsedResponse?.MB_G)
            totalOutputYear = Number(productDetails?.bi_request?.PR_PPT) - Number(incomeStartYearGFS?.label) + 1
            totalOutputYearGFS = Number(PT_Value) - Number(productDetails?.bi_request?.PR_PPT)
            startingOutPutLabel = "Get"
            outputStr = "per year for"
            totalOutputYearSuffixLabel = <span>Years + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS2)).toLocaleString('en-IN')}</ins> for {totalOutputYearGFS} Years + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS3)).toLocaleString('en-IN')}</ins> at the end of {Number(PT_Value)} Years</span>
          } else if (Number(productDetails?.bi_request?.IncomeOption) === 45 && Number(productDetails?.bi_request?.Cashback) === 35) {
            //! Income Type =  Increaing && Cashback == Yes
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              totaloutputAmtGFS = totaloutputAmtGFS + Math.round(item?.PRE_INC_BEN_SOY) + Math.round(item?.PRE_INC_BEN_EOY) + Math.round(item?.BAL_INC_EOY) + Math.round(item?.MB_G)
              outputAmtGFS = Math.round(productDetails?.firstYearResponse?.PRE_INC_BEN_SOY)
              //! Timing = Start of Year label 1
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 37) outputAmtGFS2 = Math.round(item?.PRE_INC_BEN_SOY);
              //! Timing = End of Year label 1
              if (Number(incomeStartYearGFS?.label) - 1 === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 38) outputAmtGFS2 = Math.round(item?.PRE_INC_BEN_EOY);

              //! Timing = Start of Year label 2
              if (Number(productDetails?.bi_request?.PR_PPT) === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 37) outputAmtGFS3 = Math.round(item?.PRE_INC_BEN_SOY);
              //! Timing = End of Year label 2
              if (Number(productDetails?.bi_request?.PR_PPT) === index && Number(productDetails?.bi_request?.TimingofIncomeFromIncomeStartYear) === 38) outputAmtGFS3 = Math.round(item?.PRE_INC_BEN_EOY);
              //!  label 3
              // if (Number(productDetails?.bi_request?.PR_PT) === index) outputAmtGFS4 = item?.MB_G
            });
            outputAmtGFS4 = Math.round(productDetails?.parsedResponse?.MB_G)
            totalOutputYearGFS = Number(productDetails?.bi_request?.PR_PPT) - Number(incomeStartYearGFS?.label) + 1
            startingOutPutLabel = "Get Cashback of "
            outputStr = ""
            totalOutputYear = ""
            totalOutputYearSuffixLabel = <span> + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS2)).toLocaleString('en-IN')}</ins> for {totalOutputYearGFS} Years + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS3)).toLocaleString('en-IN')}</ins> for {Number(PT_Value) - Number(productDetails?.bi_request?.PR_PPT)} Years + ₹ <ins className='font-weight-medium'>{Math.round(Number(outputAmtGFS4)).toLocaleString('en-IN')}</ins> at the end of {Number(PT_Value)} Years </span>
          }
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = yearlyInputAmount;
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = totaloutputAmtGFS;

        totalOutputAmtSuffixLabel = ""
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = outputAmtGFS
        totalOutputYear = totalOutputYear
        outputStr = outputStr;
        totalOutputYearSuffixLabel = totalOutputYearSuffixLabel;
        belowOutputYearSuffixLabel = belowOutputYearSuffixLabel;

        break;

      case ProductConstants.ASSURED_INCOME_STAR:
        yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.ANN_PREM_DISPLAY)
        // let PT_Value_AIS = Math.round(productDetails?.parsedResponse?.POLICYTERM)
        let planOption = productDetails?.bi_request?.PlanOption
        let accrualOfSurvivalBenefit = productDetails?.bi_request?.AccrualOfSurvivalBenefit_1
        let totaloutputAmtAIS = 0
        let outputAmtAIS = 0
        let extraBenefit = 0
        let countRegularIncome = 0
        let premiumOffsetOption = productDetails?.bi_request?.PremiumOffsetOption

        switch (Number(accrualOfSurvivalBenefit)) {
          case 13:
            // let fdpAsbEndYearAIS = 0
            // let fdpAsbStartYearAIS = 0
            // let asbStartYearListAIS = aisUtils.generatePredefinedOptListForAIS(1, 15)
            // let asbEndYearListAIS = aisUtils.generatePredefinedOptListForAIS(1, 55)
            // let withDrawalPercentageAIS = Number(productDetails?.bi_request?.WithdrawalPercentage_1)
            // let asbStartYearValueAIS = asbStartYearListAIS?.find((item) => Number(item?.id) === Number(productDetails?.bi_request?.ASB_StartPolicyYear_1))
            // let asbEndYearValueAIS = asbEndYearListAIS?.find((item) => Number(item?.id) === Number(productDetails?.bi_request?.ASB_EndPolicyYear_1))
            // fdpAsbEndYearAIS = asbEndYearValueAIS?.label ? asbEndYearValueAIS?.label : 0
            // fdpAsbStartYearAIS = asbStartYearValueAIS?.label ? asbStartYearValueAIS.label : 0


            // let isPartialASB = false
            // // Partial ASB means ASB Opt-Out Year is not PT-1 and % withdrawal is less than 100% BI valie is 105
            // if ((Number(fdpAsbEndYearAIS) !== Number(productDetails?.bi_request?.PR_PT) - 1) && withDrawalPercentageAIS !== 105) {
            //   isPartialASB = true
            // }
            // console.log("isPartialASB ", isPartialASB)
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              totaloutputAmtAIS = totaloutputAmtAIS + Math.round(item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY) + Math.round(item?.ADV_OTHER_BEN_DISPLAY) + Math.round(item?.MATURITY_BENEFIT) + Math.round(item?.WITHDRAWL_ACCRU_INC_BEN_PAYOUT)

              if (Number(item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY) > 0) {
                countRegularIncome = countRegularIncome + 1
              }
              extraBenefit = extraBenefit + Math.round(item?.MATURITY_BENEFIT) + Math.round(item?.WITHDRAWL_ACCRU_INC_BEN_PAYOUT)
            });
            if (Number(planOption) === 1) {
              startingOutPutLabel = "Get "
              outputAmtAIS = productDetails?.biResponseCompleteData?.find((item) => item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY != 0)?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY
              // let asbOptDiff = Number(fdpAsbStartYearAIS) - Number(fdpAsbEndYearAIS)
              // totalOutputYear = Number(productDetails?.bi_request?.PR_PT) - asbOptDiff + 1
              totalOutputYear = countRegularIncome
              outputStr = "for"
              totalOutputYearSuffixLabel = <span> Years + ₹ <ins className='font-weight-medium'>{Math.round(Number(extraBenefit)).toLocaleString('en-IN')}</ins> </span>
            } else if (Number(planOption) === 2) {
              let regularAmount = productDetails?.biResponseCompleteData?.find((item) => item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY != 0)?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY
              startingOutPutLabel = "Get Cashback of "
              outputAmtAIS = Math.round(productDetails?.firstYearResponse?.["ADV_OTHER_BEN_DISPLAY"])
              totalOutputYear = ""
              totalOutputYearSuffixLabel = <span> + ₹ <ins className='font-weight-medium'>{Math.round(Number(regularAmount)).toLocaleString('en-IN')}</ins> for {countRegularIncome} Years +  ₹ <ins className='font-weight-medium'>{Math.round(Number(extraBenefit)).toLocaleString('en-IN')}</ins> </span>
            }
            break;

          case 14:
            productDetails?.biResponseCompleteData?.forEach((item, index) => {
              totaloutputAmtAIS = totaloutputAmtAIS + Math.round(item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY) + Math.round(item?.ADV_OTHER_BEN_DISPLAY) + Math.round(item?.MATURITY_BENEFIT) + Math.round(item?.WITHDRAWL_ACCRU_INC_BEN_PAYOUT)
              if (Number(item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY) > 0) {
                countRegularIncome = countRegularIncome + 1
              }
              extraBenefit = extraBenefit + Math.round(item?.MATURITY_BENEFIT) + Math.round(item?.WITHDRAWL_ACCRU_INC_BEN_PAYOUT)

            });
            let regularAmount = productDetails?.biResponseCompleteData?.find((item) => item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY != 0)?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY
            if (Number(planOption) === 1) {
              // Get Rs B for PT Years
              startingOutPutLabel = "Get "
              outputAmtAIS = regularAmount
              totalOutputYear = Number(countRegularIncome)
              outputStr = "for"
              totalOutputYearSuffixLabel = <span> years +  ₹ <ins className='font-weight-medium'>{Math.round(Number(extraBenefit)).toLocaleString('en-IN')}</ins>  </span>
            } else if (Number(planOption) === 2) {
              //  Get Cashback of Rs A + Rs B for PT-1 Years
              let regularAmount = productDetails?.biResponseCompleteData?.find((item) => item?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY != 0)?.INC_BEN_PAYOUT_LOYALTY_ADD_DISPLAY
              startingOutPutLabel = "Get Cashback of "
              outputAmtAIS = Math.round(productDetails?.firstYearResponse?.["ADV_OTHER_BEN_DISPLAY"])
              totalOutputYear = ""
              totalOutputYearSuffixLabel = <span> + ₹ <ins className='font-weight-medium'>{Math.round(Number(regularAmount)).toLocaleString('en-IN')}</ins> for {Number(countRegularIncome)} Years +  ₹ <ins className='font-weight-medium'>{Math.round(Number(extraBenefit)).toLocaleString('en-IN')}</ins>  </span>
            }
            break;

          default:
            break;
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = yearlyInputAmount;
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = totaloutputAmtAIS;

        totalOutputAmtSuffixLabel = ""
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = outputAmtAIS
        totalOutputYear = totalOutputYear
        outputStr = outputStr;
        totalOutputYearSuffixLabel = totalOutputYearSuffixLabel;
        belowOutputYearSuffixLabel = belowOutputYearSuffixLabel;

        break;

      case ProductConstants.GCAP:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        inputAmount = Math.round(yearlyInputAmount) * Number(productDetails?.bi_request?.PR_PPT);
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(productDetails?.parsedResponse?.MATURITY);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true
        break;

      case ProductConstants.DHAN_LABH:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        inputAmount = Math.round(yearlyInputAmount) * Number(productDetails?.bi_request?.PR_PPT);
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(productDetails?.parsedResponse?.TOTAL_BEN);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true;
        break;

      case ProductConstants.SMART_LIFESTYLE:
      case ProductConstants.FAMILY_PROTECTION_OPTION_SMART_LIFESTYLE:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        inputAmount = Math.round(yearlyInputAmount) * Number(productDetails?.bi_request?.PR_PPT);
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(productDetails?.parsedResponse?.SB_NG_DIS_BS_2);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true
        break;

      case ProductConstants.SINGLE_PAY_ENDOWMENT_ASSUARANCE_PLAN:
        inputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        yearlyInputAmount = "";
        inputStr = "";
        totalInputYear = "";
        totalInputYearSuffixLabel = "";
        outputAmt = Math.round(productDetails?.parsedResponse?.SB_G);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true;
        break;

      case ProductConstants.WEALTH_PLUS:
      case ProductConstants.RISING_STAR_WEALTH_PLUS:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.PREMIUM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.PREMIUM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.PREMIUM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.PREMIUM) * 12
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = Number(productDetails?.bi_request?.PR_PPT);
        totalInputYearSuffixLabel = "";
        outputAmt = Math.round(productDetails?.parsedResponse?.FINAL_FV);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.WEALTH_PREMIER:
        inputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        yearlyInputAmount = "";
        inputStr = "";
        totalInputYear = "";
        totalInputYearSuffixLabel = "";
        outputAmt = Math.round(productDetails?.parsedResponse?.FINAL_FV);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        break;

      case ProductConstants.WEALTH_ULTIMA:
      case ProductConstants.LITTLE_CHAMP_WEALTH_ULTIMA:
        // if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        // } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) / 2
        // } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) / 4
        // } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) / 12
        // }
        inputAmount = Math.round(Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * productDetails?.bi_request?.PR_PPT);
        yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(productDetails?.parsedResponse?.FINAL_FV);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true
        break;

      case ProductConstants.SYSTEMATIC_WITHDRAWAL_PLAN_WEALTH_ULTIMA:
        // if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        // } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) / 2
        // } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) / 4
        // } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
        //   yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) / 12
        // }
        let swpStartYear = productDetails?.bi_request?.optionValue6;
        let swpStartYearData = productDetails?.biResponseCompleteData ? productDetails?.biResponseCompleteData[swpStartYear - 1] : 0;
        let targetValue = 0;
        let totalOutPutAmt = 0;
        if ((swpStartYearData?.TOTALPW && swpStartYearData?.TOTALPW) > 0) {
          targetValue = Math.round(swpStartYearData?.TOTALPW);
        }
        productDetails?.biResponseCompleteData?.forEach((item) => totalOutPutAmt += Math.round(item?.TOTALPW))

        totalOutPutAmt += Math.round(productDetails?.parsedResponse?.FINAL_FV)
        inputAmount = Math.round(Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * productDetails?.bi_request?.PR_PPT);
        yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(totalOutPutAmt);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = targetValue;
        outputStr = "per annum for ";
        totalOutputYear = parseInt(productDetails?.bi_request?.PR_PT) - parseInt(swpStartYear) + 1;

        totalOutputYearSuffixLabel = "years ";
        additionalOutputAmt = ` ₹ ${Math.round(productDetails?.parsedResponse?.FINAL_FV).toLocaleString('en-IN')}`;
        outputNote = "Amount changes every year.";
        belowOutputYearSuffixLabel = "Increases every year";
        break;

      case ProductConstants.POS_SARAL_NIVESH:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(productDetails?.parsedResponse?.SB_G);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        additionalOutputAmt = "";
        outputNote = "";
        showPayoutPeriodMsg = true
        break;


      case ProductConstants.FLEXI_SAVINGS_PLAN_CHILD_FLEXI_INCOME:
      case ProductConstants.FLEXI_SAVINGS_PLAN_FLEXI_INCOME:
        let fspWithoutAccrualTargetAmtPostPPT = 0
        let fspWithoutAccrualTargetAmtDuringPPT = 0
        let fspWithoutAccrualTotalTargetAmt = 0
        let incomeStartYearLessThanPPT = false
        let fspMaturityBenefit = 0
        let fspWithoutAccrualPtValue = productDetails?.bi_request?.PR_PT === '100-@LI_ENTRY_AGE' ? 100 - Number(productDetails?.bi_request?.LI_ENTRY_AGE) : Number(productDetails?.bi_request?.PR_PT)
        let incomeStartYear = Number(productDetails?.bi_request?.IncomeStartYear)
        if (incomeStartYear === 4) incomeStartYear = 2
        if (incomeStartYear === 5) incomeStartYear = 5
        if (incomeStartYear === 6) incomeStartYear = 9
        if (incomeStartYear === 7) incomeStartYear = 11
        if (incomeStartYear === 8) incomeStartYear = 13
        if (incomeStartYear === 9) incomeStartYear = 16

        let finalpremium = 0;
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        let lastYearMaturityBenefit = Math.round(productDetails?.parsedResponse?.MATURITY_BENEFIT_BS_2)
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          if (Number(productDetails?.bi_request?.PR_PPT) === index) fspWithoutAccrualTargetAmtPostPPT = Math.round(item.TOTAL_SB_PAYOUT_BS_2);
          if (lastYearMaturityBenefit !== 0) {
            fspMaturityBenefit = lastYearMaturityBenefit
          } else {
            if (fspWithoutAccrualPtValue - 1 === index && fspMaturityBenefit === 0) fspMaturityBenefit = Math.round(item?.MATURITY_BENEFIT_BS_2);
          }
        });

        let ptValue = 0;
        if (productDetails?.bi_request?.PR_PT == "100-@LI_ENTRY_AGE") {
          ptValue = 100 - Number(productDetails?.bi_request?.LI_ENTRY_AGE);
        }
        else {
          ptValue = Number(productDetails?.bi_request?.PR_PT)
        }
        let yYears = ptValue - Number(productDetails?.bi_request?.PR_PPT)

        if (incomeStartYear < Number(productDetails?.bi_request?.PR_PPT)) {
          let aYears = Number(productDetails?.bi_request?.PR_PPT) - incomeStartYear + 1
          incomeStartYearLessThanPPT = true

          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            if (fspWithoutAccrualTargetAmtDuringPPT === 0 && Math.round(item.TOTAL_SB_PAYOUT_BS_2) !== 0) fspWithoutAccrualTargetAmtDuringPPT = Math.round(item.TOTAL_SB_PAYOUT_BS_2);

            fspWithoutAccrualTotalTargetAmt += Math.round(item.TOTAL_SB_PAYOUT_BS_2)
          });
          totalOutputYearSuffixLabel = <span>{aYears} years + ₹ <ins className='font-weight-medium'>{Math.round(fspWithoutAccrualTargetAmtPostPPT).toLocaleString('en-IN')}</ins> per annum for {yYears} years + ₹ {Math.round(fspMaturityBenefit).toLocaleString('en-IN')}</span>
          // totalOutputYearSuffixLabel = `${aYears} years + ₹ ${fspWithoutAccrualTargetAmtPostPPT} per annum for ${yYears} years + ₹ ${Math.round(fspMaturityBenefit)}`
          yearlyOutputAmountBold = false
        } else {

          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            fspWithoutAccrualTotalTargetAmt += Math.round(item.TOTAL_SB_PAYOUT_BS_2);
          });
          totalOutputYearSuffixLabel = <span>{yYears} years + ₹ {Math.round(fspMaturityBenefit).toLocaleString('en-IN')}</span>
          // totalOutputYearSuffixLabel = `${yYears} years + ₹ ${Math.round(fspMaturityBenefit)}`
        }

        if (Number(productDetails?.bi_request?.AccrualOfSurvivalBenefits) === 12) {
          totalOutputAmtSuffixLabel = "";
          yearlyOutputAmount = incomeStartYearLessThanPPT ? fspWithoutAccrualTargetAmtDuringPPT : fspWithoutAccrualTargetAmtPostPPT;
          outputStr = "per annum";
          totalOutputYear = "for";
          totalOutputYearSuffixLabel = totalOutputYearSuffixLabel;
          belowOutputYearSuffixLabel = "";
        } else {
          onlyShowBelowOutputYearSuffixLabel = true
          belowOutputYearSuffixLabel = "[ Refer cashflow table for details ]"
        }
        outputAmt = fspWithoutAccrualTotalTargetAmt + Math.round(fspMaturityBenefit);
        if (Number(productDetails?.bi_request?.AccrualOfSurvivalBenefits) === 13) {
          outputAmt = outputAmt + Math.round(productDetails?.parsedResponse?.ACCRUAL_TOTAL_BS_2)
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        break;

      case ProductConstants.FLEXI_SAVINGS_PLAN_CHILD_FLEXI_INCOME_PRO:
      case ProductConstants.FLEXI_SAVINGS_PLAN_FLEXI_INCOME_PRO:
        let fspProWithoutAccrualTargetAmtPostPPT = 0
        let fspProWithoutAccrualTotalTargetAmt = 0
        let fspProMaturityBenefit = 0
        let fspProWithoutAccrualPtValue = productDetails?.bi_request?.PR_PT === '100-@LI_ENTRY_AGE' ? 100 - Number(productDetails?.bi_request?.LI_ENTRY_AGE) : Number(productDetails?.bi_request?.PR_PT)

        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }

        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          if (Number(productDetails?.bi_request?.PR_PPT) === index) fspProWithoutAccrualTargetAmtPostPPT = Math.round(item.TOTAL_SB_PAYOUT_BS_2);
          if (fspProWithoutAccrualPtValue - 1 === index && fspProMaturityBenefit === 0) fspProMaturityBenefit = Math.round(item?.MATURITY_BENEFIT_BS_2);
        });

        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          fspProWithoutAccrualTotalTargetAmt += Math.round(item.TOTAL_SB_PAYOUT_BS_2);
        });

        if (Number(productDetails?.bi_request?.AccrualOfSurvivalBenefits) === 12) {
          totalOutputAmtSuffixLabel = "";
          yearlyOutputAmount = fspProWithoutAccrualTargetAmtPostPPT;
          outputStr = "per annum";
          totalOutputYear = `+ ₹ ${Math.round(fspProMaturityBenefit).toLocaleString('en-IN')}`;
          totalOutputYearSuffixLabel = "+ Other Income";
          belowOutputYearSuffixLabel = "Refer CashFlow Table for detailed info.";
        } else {
          onlyShowBelowOutputYearSuffixLabel = true
          belowOutputYearSuffixLabel = "[ Refer cashflow table for details ]"
        }
        outputAmt = fspProWithoutAccrualTotalTargetAmt + Math.round(fspProMaturityBenefit);
        if (Number(productDetails?.bi_request?.AccrualOfSurvivalBenefits) === 13) {
          outputAmt = outputAmt + Math.round(productDetails?.parsedResponse?.ACCRUAL_TOTAL_BS_2)
        }
        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        break;

      case ProductConstants.FLEXI_SAVINGS_PLAN_CHILD_SYSTEMATIC_WITHDRAWAL:
      case ProductConstants.FLEXI_SAVINGS_PLAN_CHILD_AGE_BASED_WITHDRAWAL:
      case ProductConstants.FLEXI_SAVINGS_PLAN_CHILD_AGE_PLUS_INCOME_BASED_WITHDRAWAL:
      case ProductConstants.FLEXI_SAVINGS_PLAN_SYSTEMATIC_WITHDRAWAL:
      case ProductConstants.FLEXI_SAVINGS_PLAN_AGE_BASED_WITHDRAWAL:
      case ProductConstants.FLEXI_SAVINGS_PLAN_AGE_PLUS_INCOME_BASED_WITHDRAWAL:
      case ProductConstants.FLEXI_SAVINGS_PLAN_CHILD_FLEXI_INCOME_PRO:
      case ProductConstants.FLEXI_SAVINGS_PLAN_FLEXI_INCOME_PRO:
        let fspProWithAccrualTargetAmtPostPPT = 0
        let fspProWithAccrualTotalTargetAmt = 0
        let fspProWithAccrualMaturityBenefit = 0
        let fspProWithAccrualPtValue = productDetails?.bi_request?.PR_PT === '100-@LI_ENTRY_AGE' ? 100 - Number(productDetails?.bi_request?.LI_ENTRY_AGE) : Number(productDetails?.bi_request?.PR_PT)
        if (Number(productDetails?.bi_request?.AccrualOfSurvivalBenefits) === 13) {

          if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
            yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
          } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
            yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
          } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
            yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
          } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
            yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
          }

          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            if (Number(productDetails?.bi_request?.PR_PPT) === index) fspProWithAccrualTargetAmtPostPPT = Math.round(item.TOTAL_SB_POST_PPT_BS_2);
            if (fspProWithAccrualPtValue - 1 === index && fspProWithAccrualMaturityBenefit === 0) fspProWithAccrualMaturityBenefit = Math.round(item?.MATURITY_BENEFIT_BS_2);
          });
          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            fspProWithAccrualTotalTargetAmt += Math.round(item.TOTAL_SB_PAYOUT_BS_2);
          });

          inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
          yearlyInputAmount = Math.round(yearlyInputAmount);
          inputStr = "per annum";
          totalInputYear = productDetails?.bi_request?.PR_PPT;
          totalInputYearSuffixLabel = "years";
          outputAmt = fspProWithAccrualTotalTargetAmt + Math.round(fspProWithAccrualMaturityBenefit);
          totalOutputAmtSuffixLabel = "";
          yearlyOutputAmount = fspProWithAccrualTargetAmtPostPPT;
          outputStr = "per annum";
          totalOutputYear = `+ ₹ ${Math.round(fspProWithAccrualMaturityBenefit).toLocaleString('en-IN')}`;
          totalOutputYearSuffixLabel = "+ Other Income";
          belowOutputYearSuffixLabel = "Refer CashFlow Table for detailed info.";
        }
        break;

      case ProductConstants.FLEXI_SAVINGS_PLAN_CHILD_LARGE_SUM_OPTION:
      case ProductConstants.FLEXI_SAVINGS_PLAN_LARGE_SUM_OPTION:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        let targetAmtFinal = 0;
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          if ((Number(productDetails?.bi_request?.PR_PT) - 1) == index) {
            targetAmtFinal = Math.round(item.MATURITY_BENEFIT_BS_2);
          }
        });

        inputAmount = Math.round(yearlyInputAmount * Number(productDetails?.bi_request?.PR_PPT));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(targetAmtFinal);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = "";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        showPayoutPeriodMsg = true
        break;

      case ProductConstants.BHARAT_SAVINGS_STAR_INCOME:
      case ProductConstants.POS_BHARAT_SAVINGS_STAR_INCOME:
      case ProductConstants.BHARAT_SAVINGS_STAR_LUMPSUM:
      case ProductConstants.POS_BHARAT_SAVINGS_STAR_LUMPSUM:
        if (Number(productDetails?.bi_request?.INPUT_MODE) === 1) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM)
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 2) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 2
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 3) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 4
        } else if (Number(productDetails?.bi_request?.INPUT_MODE) === 4) {
          yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.MODAL_PREM) * 12
        }
        yearlyOutputAmount = 0
        let totalInputYearCount = 0
        totalOutputYear = 0
        let targetAmountPostPPT = 0
        let autoRenewalBooster = 0
        let totalOutputYearPostPPT = 0
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          if (Math.round(item?.MODAL_PREM) !== 0) totalInputYearCount += 1
          if (Number(productDetails?.bi_request?.PR_PPT) < index && item.IB_PAY_WO_AP !== 0 && targetAmountPostPPT === 0) targetAmountPostPPT = Math.round(item.IB_PAY_WO_AP)
          outputAmt += (Math.round(item.IB_PAY_WO_AP) + Math.round(item.MB_G))
        })
        if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 439) {
          autoRenewalBooster = productDetails?.biResponseCompleteData?.find((item) => item.AUTO_RENEW_BOOSTER != 0)?.AUTO_RENEW_BOOSTER
          if (autoRenewalBooster) {
            outputAmt += Math.round(autoRenewalBooster)
          }
        }

        if (Number(productDetails?.bi_request?.PlanOption) === 1) {
          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            if (item.IB_PAY_WO_AP !== 0 && yearlyOutputAmount === 0) yearlyOutputAmount = Math.round(item.IB_PAY_WO_AP)
            if (Number(productDetails?.bi_request?.PR_PPT) > index && item.IB_PAY_WO_AP !== 0) totalOutputYear += 1;
            if (Number(productDetails?.bi_request?.PR_PPT) <= index && item.IB_PAY_WO_AP !== 0) totalOutputYearPostPPT += 1

          })
          totalOutputYearSuffixLabel = <span> ₹ <ins className='font-weight-medium'>{Math.round(targetAmountPostPPT).toLocaleString('en-IN')}</ins> per annum for {Number(totalOutputYearPostPPT)} years {autoRenewalBooster !== 0 && '+ ₹ ' + Math.round(autoRenewalBooster || 0).toLocaleString('en-IN')} + ₹ {Math.round(productDetails?.parsedResponse?.MB_G).toLocaleString('en-IN')}</span>

        } else {
          productDetails?.biResponseCompleteData?.forEach((item, index) => {
            if (Number(productDetails?.bi_request?.PR_PPT) <= index && item.IB_PAY_WO_AP !== 0) totalOutputYear += 1
          })
          yearlyOutputAmount = targetAmountPostPPT
          totalOutputYearSuffixLabel = <span>years {autoRenewalBooster !== 0 && '+ ₹ ' + Math.round(autoRenewalBooster || 0).toLocaleString('en-IN')} + ₹ {Math.round(productDetails?.parsedResponse?.MB_G).toLocaleString('en-IN')}</span>
        }

        inputAmount = Math.round(yearlyInputAmount * Number(totalInputYearCount));
        yearlyInputAmount = Math.round(yearlyInputAmount);
        inputStr = "per annum";
        totalInputYear = totalInputYearCount;
        totalInputYearSuffixLabel = "years";
        outputAmt = Math.round(outputAmt);
        totalOutputAmtSuffixLabel = "";
        yearlyOutputAmount = yearlyOutputAmount;
        outputStr = "per annum for";
        totalOutputYear = totalOutputYear;
        totalOutputYearSuffixLabel = totalOutputYearSuffixLabel;
        belowOutputYearSuffixLabel = "Refer Cashflow Table for Details";
        break;

      case ProductConstants.LEGACY_PLUS_INCOME:

        let lpinputAmount = 0
        let lpoutputAmt = 0
        let lpyearlyOutputAmount = productDetails?.biResponseCompleteData[0]?.TOTAL_SB_G_BS_2
        let lptotalOutputYearSuffixLabel = ""
        let lptargetAmountForRemaindYear = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT]?.TOTAL_SB_G_BS_2
        let lptargetAmountForRemaindCount = 0
        let accBenefit = 0
        let fixIncome = 0
        let lpyearlyInputAmount = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT - 1]?.ANN_PREM_YEARLY
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          //you pay
          if (Number(productDetails?.bi_request?.PR_PPT) >= index) {
            lpinputAmount += item.ANN_PREM_YEARLY
          }
          // you get

          lpoutputAmt += item.TOTAL_SB_G_BS_2 + item.PAYOUT_ACC_SB_G_BS_2

          if (index != 0 && item.TOTAL_SB_G_BS_2 > 0) {
            lptargetAmountForRemaindCount += 1
            fixIncome = item.TOTAL_SB_G_BS_2
          }

          if (item.PAYOUT_ACC_SB_G_BS_2 > 0) {
            accBenefit += item.PAYOUT_ACC_SB_G_BS_2
          }



        })
        // 1st  + remain year calculation
        let accBenefitLabel = accBenefit > 0 ? <span>+ ₹ {Math.round(accBenefit).toLocaleString('en-IN')}</span> : ''
        lptotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(lptargetAmountForRemaindCount)} years {accBenefitLabel} + ₹ {Math.round(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_G_BS_2).toLocaleString('en-IN')} </span>

        // TOTAL_SB_G_BS_2 * pt + TOTAL_MB_G_BS_2 for last year
        outputAmt = lpoutputAmt + productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_G_BS_2
        // ANN_PREM_YEARLY * ppt
        inputAmount = lpinputAmount
        yearlyInputAmount = lpyearlyInputAmount
        yearlyOutputAmount = Math.round(lpyearlyOutputAmount) > 0 ? Math.round(lpyearlyOutputAmount) : 0;
        inputStr = "per annum";
        outputStr = Math.round(lpyearlyOutputAmount) > 0 ? "for 1st year +" : "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = lptotalOutputYearSuffixLabel
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        belowOutputYearSuffixLabel = "Refer Cashflow Table for Details";
        break;

      case ProductConstants.ACTIVE_PENSION_PLUS:
        let targetAmountNewAnnuity = Math.round(productDetails?.biResponseCompleteData.find(item => item.ANN_WT_ACC_PAY !== 0).ANN_WT_ACC_PAY)
        let totalinputAmountForAPP = 0

        // productDetails?.biResponseCompleteData?.forEach((item, index) => {
        //   outputAmt += item.ANN_WT_ACC_PAY
        // })
        // if (Number(productDetails?.bi_request?.AnnuityMode) === 21) {
        //   outputAmt = Math.round(targetAmountNewAnnuity)
        // } else if (Number(productDetails?.bi_request?.AnnuityMode) === 22) {
        //   outputAmt = Math.round(targetAmountNewAnnuity * 2)
        // } else if (Number(productDetails?.bi_request?.AnnuityMode) === 23) {
        //   outputAmt = Math.round(targetAmountNewAnnuity * 4)
        // } else {
        //   outputAmt = Math.round(targetAmountNewAnnuity * 12)
        // }
        outputAmt = targetAmountNewAnnuity
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          if (Number(productDetails?.bi_request?.PR_PPT) >= index) {
            totalinputAmountForAPP += item.ANN_PREM_YEARLY
          }
        })

        inputAmount = Math.round(totalinputAmountForAPP);
        yearlyInputAmount = Math.round(productDetails?.firstYearResponse?.ANN_PREM_YEARLY);;
        inputStr = "per annum";
        totalInputYear = productDetails?.bi_request?.PR_PPT;;
        totalInputYearSuffixLabel = "";
        outputAmt = outputAmt;
        totalOutputAmtSuffixLabel = "per annum" + " " + "for Lifetime";
        yearlyOutputAmount = "";
        outputStr = outputStr;
        totalOutputYear = "";
        totalOutputYearSuffixLabel = "";
        belowOutputYearSuffixLabel = "";
        totalInputYearSuffixLabel = "years";
        break;


      case ProductConstants.LEGACY_PLUS_LUMPSUM:
        let lplsinputAmount = 0
        let lplsyearlyInputAmount = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT - 1]?.ANN_PREM_YEARLY
        let lplstotalOutputYearSuffixLabel = ""
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          //you pay
          if (Number(productDetails?.bi_request?.PR_PPT) >= index) {
            lplsinputAmount += item.ANN_PREM_YEARLY
          }

        })
        lplstotalOutputYearSuffixLabel = <span>After a period of {productDetails?.biResponseCompleteData.length} years</span>
        outputAmt = productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.PAYOUT_ACC_SB_G_BS_2
        inputAmount = lplsinputAmount
        yearlyInputAmount = lplsyearlyInputAmount
        yearlyOutputAmount = 0;
        inputStr = "per annum";
        outputStr = "";
        totalOutputYear = "";
        totalOutputYearSuffixLabel = lplstotalOutputYearSuffixLabel
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";

        break;

      case ProductConstants.FLEXI_DREAM_PLAN:

        let fdpinputAmount = 0
        let fdpoutputAmt = 0
        let fdpyearlyOutputAmount = 0
        let fdptotalOutputYearSuffixLabel = ""
        let fdptargetAmountForRemaindYear = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT]?.ACCRU_OF_SB_4
        let fdptargetAmountForRemaindCount = 0
        let fdpAsbEndYear = 0
        let fdpAsbStartYear = 0
        let fdpfixIncome = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT]?.PAYOUT_OF_ACCRU_OF_SB_8
        let fdpyearlyInputAmount = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT - 1]?.ANN_PREM_DISP
        console.log("productDetails?.biResponseCompleteData", productDetails?.biResponseCompleteData)

        // let asbStartYearList = fdpUtils.generatePredefinedOptListForLP(0, 31)
        // let asbEndYearList = fdpUtils.generatePredefinedOptListForLP(0, 132)
        // let withDrawalPercentage = Number(productDetails?.bi_request?.WithdrawalPercentage_1)
        // let asbStartYearValue = asbStartYearList.find((item) => Number(item?.id) === Number(productDetails?.bi_request?.ASB_StartPolicyYear_1))
        // let asbEndYearValue = asbEndYearList.find((item) => Number(item?.id) === Number(productDetails?.bi_request?.ASB_EndPolicyYear_1))
        // fdpAsbEndYear = asbEndYearValue?.label ? asbEndYearValue?.label : 0
        // fdpAsbStartYear = asbStartYearValue?.label ? asbStartYearValue.label : 0
        // let asbValue = Number(productDetails?.bi_request?.AccrualOfSurvivalBenefit_1)
        // let acc_period = fdpUtils.accurealPeriodValue(Number(productDetails?.bi_request?.AccrualPeriod))
        // let extralabel = "for 2nd year + "
        // if (asbValue === 29) {
        //   if (Number(fdpAsbStartYear) >= 3) {
        //     fdpfixIncome = productDetails?.biResponseCompleteData[Number(fdpAsbStartYear) - 2]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   } else {
        //     fdpfixIncome = productDetails?.biResponseCompleteData[Number(fdpAsbEndYear) + 1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   }
        // }

        // if (Number(productDetails?.bi_request?.AccrualPeriod)) {
        //   if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //     fdpfixIncome = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + acc_period + 2]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   } else {
        //     fdpfixIncome = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + acc_period + 1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   }
        // }
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          //you pay
          if (Number(productDetails?.bi_request?.PR_PPT) >= index) {
            fdpinputAmount += item.ANN_PREM_DISP
          }
          // you get
          fdpoutputAmt += Number(item?.PAYOUT_OF_ACCRU_OF_SB_8) + Number(item?.TOTAL_MB_BS_1)
          console.log("fdptargetAmountForRemaindCount", fdptargetAmountForRemaindCount)
          if (Number(item.PAYOUT_OF_ACCRU_OF_SB_8) === Number(fdpfixIncome)) {
            fdptargetAmountForRemaindCount += 1
            // if (Number(productDetails?.bi_request?.PR_PPT) === index) {
            //   fdpfixIncome = Number(item.PAYOUT_OF_ACCRU_OF_SB_8)
            // }
          }
        })

        // switch (asbValue) {
        //   case 29:
        //     fdpyearlyOutputAmount = productDetails?.biResponseCompleteData[1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //     if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 0 && Number(productDetails?.bi_request?.IsExistingCustomer) === 2) {
        //       fdpyearlyOutputAmount = 0
        //     } else if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //       // fdptargetAmountForRemaindCount = fdptargetAmountForRemaindCount - 1
        //       fdpyearlyOutputAmount = productDetails?.biResponseCompleteData[1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //     }

        //     let policyLength = productDetails?.biResponseCompleteData.length
        //     let benefit = (withDrawalPercentage !== 333 || Number(policyLength) === Number(asbEndYearValue?.label)) ? Number(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.PAYOUT_OF_ACCRU_OF_SB_8) + Number(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1) : Number(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1)
        //     let countOfAfterAsbFixamount = Number(productDetails?.biResponseCompleteData.length) - Number(fdpAsbEndYear) - 1
        //     console.log("countOfAfterAsbFixamount ", countOfAfterAsbFixamount)
        //     // fdptotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fdpfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(fdpAsbStartYear - 1)} years + {countOfAfterAsbFixamount >= 0 && <span>{Math.round(productDetails?.biResponseCompleteData[fdpAsbEndYear - 1]?.PAYOUT_OF_ACCRU_OF_SB_8).toLocaleString('en-IN')} for {fdpAsbEndYear}th year + </span>}  {countOfAfterAsbFixamount > 0 && <span>{Math.round(fdpfixIncome).toLocaleString('en-IN')} for {countOfAfterAsbFixamount} years + </span>} ₹ {Math.round(benefit).toLocaleString('en-IN')}  </span>
        //     fdptotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fdpfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(fdptargetAmountForRemaindCount)} years + {(countOfAfterAsbFixamount >= 0 && withDrawalPercentage !== 233) && <span>{Math.round(productDetails?.biResponseCompleteData[fdpAsbEndYear - 1]?.PAYOUT_OF_ACCRU_OF_SB_8).toLocaleString('en-IN')} + </span>}  ₹ {Math.round(benefit).toLocaleString('en-IN')}  </span>

        //     break;

        //   case 30:

        //     if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 0 && Number(productDetails?.bi_request?.IsExistingCustomer) === 2) {
        //       fdpyearlyOutputAmount = 0
        //     } else if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //       // fdptargetAmountForRemaindCount = fdptargetAmountForRemaindCount - 1
        //       fdpyearlyOutputAmount = productDetails?.biResponseCompleteData[1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //     }
        //     fdptotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fdpfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(fdptargetAmountForRemaindCount)} years + ₹ {Math.round(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1).toLocaleString('en-IN')} </span>
        //     break;
        //   default:
        //     break;
        // }

        // if (Number(productDetails?.bi_request?.Proposition) === 1) {
        //   fdptotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fdpoutputAmt).toLocaleString('en-IN')}</ins> After a period of {productDetails?.biResponseCompleteData?.length} years</span>
        // }

        // if (Number(productDetails?.bi_request?.AccrualPeriod)) {
        //   if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //     extralabel = `for ${Number(productDetails?.bi_request?.PR_PPT) + acc_period}nd year + `
        //     fdpyearlyOutputAmount = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + acc_period]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   }
        //   let count = productDetails?.biResponseCompleteData.filter((items) => Number(Math.round(items.PAYOUT_OF_ACCRU_OF_SB_8)) === Number(Math.round(fdpfixIncome)))
        //   fdptotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fdpfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(count?.length)} years + ₹ {Math.round(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1).toLocaleString('en-IN')} </span>
        // }

        outputAmt = Math.round(fdpoutputAmt)
        // ANN_PREM_YEARLY * ppt
        inputAmount = fdpinputAmount
        yearlyInputAmount = fdpyearlyInputAmount
        // yearlyOutputAmount = Math.round(fdpyearlyOutputAmount) > 0 ? Math.round(fdpyearlyOutputAmount) : 0;
        yearlyOutputAmount = ""
        inputStr = "per annum";
        // outputStr = Math.round(fdpyearlyOutputAmount) > 0 ? extralabel : "";
        outputStr = ""
        totalOutputYear = "";
        // totalOutputYearSuffixLabel = fdptotalOutputYearSuffixLabel
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        belowOutputYearSuffixLabel = "Refer Cashflow Table for Details";
        break;

      case ProductConstants.FLEXI_GOAL_SECURE:

        let fgsinputAmount = 0
        let fgsoutputAmt = 0
        let fgsyearlyOutputAmount = 0
        let fgstotalOutputYearSuffixLabel = ""
        let fgstargetAmountForRemaindYear = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT]?.ACCRU_OF_SB_4
        let fgstargetAmountForRemaindCount = 0
        let fgsAsbEndYear = 0
        let fgsAsbStartYear = 0
        let fgsfixIncome = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT]?.PAYOUT_OF_ACCRU_OF_SB_8
        let fgsyearlyInputAmount = productDetails?.biResponseCompleteData[productDetails?.bi_request?.PR_PPT - 1]?.ANN_PREM_DISP
        console.log("productDetails?.biResponseCompleteData", productDetails?.biResponseCompleteData)

        let fgsStartYearList = fgsUtils.generatePredefinedOptListForLP(0, 29)
        let fgsEndYearList = fgsUtils.generatePredefinedOptListForLP(0, 130)
        let fgsWithDrawalPercentage = Number(productDetails?.bi_request?.WithdrawalPercentage_1)
        let fgsAsbStartYearValue = fgsStartYearList.find((item) => Number(item?.id) === Number(productDetails?.bi_request?.ASB_StartPolicyYear_1))
        let fgsAsbEndYearValue = fgsEndYearList.find((item) => Number(item?.id) === Number(productDetails?.bi_request?.ASB_EndPolicyYear_1))
        fgsAsbEndYear = fgsAsbEndYearValue?.label ? fgsAsbEndYearValue?.label : 0
        fgsAsbStartYear = fgsAsbStartYearValue?.label ? fgsAsbStartYearValue.label : 0
        let fgsAsbValue = Number(productDetails?.bi_request?.AccumulationofSurvivalBenefit)
        // let fgsAcc_period = fgsUtils.accurealPeriodValue(Number(productDetails?.bi_request?.AccrualPeriod))
        let fgsExtralabel = "for 2nd year + "
        // if (fgsAsbValue === 23) {
        //   if (Number(fgsAsbStartYear) >= 3) {
        //     fgsfixIncome = productDetails?.biResponseCompleteData[Number(fgsAsbStartYear) - 2]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   } else {
        //     fgsfixIncome = productDetails?.biResponseCompleteData[Number(fgsAsbEndYear) + 1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   }
        // }

        // if (Number(productDetails?.bi_request?.AccrualPeriod)) {
        //   if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //     fgsfixIncome = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + fgsAcc_period + 2]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   } else {
        //     fgsfixIncome = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + fgsAcc_period + 1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   }
        // }
        productDetails?.biResponseCompleteData?.forEach((item, index) => {
          //you pay
          if (Number(productDetails?.bi_request?.PR_PPT) >= index) {
            fgsinputAmount += item.ANN_PREM_DISP
          }
          // you get
          fgsoutputAmt += Math.round(Number(item?.PAYOUT_OF_ACCRU_OF_SB_8)) + Math.round(Number(item?.TOTAL_MB_BS_1))
          console.log("fgstargetAmountForRemaindCount", fgstargetAmountForRemaindCount)
          if (Number(item.PAYOUT_OF_ACCRU_OF_SB_8) === Number(fgsfixIncome)) {
            fgstargetAmountForRemaindCount += 1
            // if (Number(productDetails?.bi_request?.PR_PPT) === index) {
            //   fgsfixIncome = Number(item.PAYOUT_OF_ACCRU_OF_SB_8)
            // }
          }
        })

        // switch (fgsAsbValue) {
        //   case 23:
        //     fgsyearlyOutputAmount = productDetails?.biResponseCompleteData[1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //     if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 2 && Number(productDetails?.bi_request?.IsExistingCustomer) === 2) {
        //       fgsyearlyOutputAmount = 0
        //     } else if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //       // fgstargetAmountForRemaindCount = fgstargetAmountForRemaindCount - 1
        //       fgsyearlyOutputAmount = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) - 1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //       fgsExtralabel = `at ${productDetails?.bi_request?.PR_PPT} year +`
        //     }

        //     let policyLength = productDetails?.biResponseCompleteData.length
        //     let benefit = (fgsWithDrawalPercentage !== 331 || Number(policyLength) === Number(fgsAsbEndYearValue?.label)) ? Number(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.PAYOUT_OF_ACCRU_OF_SB_8) + Number(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1) : Number(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1)
        //     let countOfAfterAsbFixamount = Number(productDetails?.biResponseCompleteData.length) - Number(fgsAsbEndYear) - 1
        //     // console.log("countOfAfterAsbFixamount ", countOfAfterAsbFixamount)
        //     // fgstotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fgsfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(fgsAsbStartYear - 1)} years + {countOfAfterAsbFixamount >= 0 && <span>{Math.round(productDetails?.biResponseCompleteData[fgsAsbEndYear - 1]?.PAYOUT_OF_ACCRU_OF_SB_8).toLocaleString('en-IN')} for {fgsAsbEndYear}th year + </span>}  {countOfAfterAsbFixamount > 0 && <span>{Math.round(fgsfixIncome).toLocaleString('en-IN')} for {countOfAfterAsbFixamount} years + </span>} ₹ {Math.round(benefit).toLocaleString('en-IN')}  </span>
        //     fgstotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fgsfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(fgstargetAmountForRemaindCount)} years + {(countOfAfterAsbFixamount >= 0 && fgsWithDrawalPercentage !== 233) && <span>{Math.round(productDetails?.biResponseCompleteData[fgsAsbEndYear - 1]?.PAYOUT_OF_ACCRU_OF_SB_8).toLocaleString('en-IN')} + </span>}  ₹ {Math.round(benefit).toLocaleString('en-IN')}  </span>

        //     break;

        //   case 24:

        //     if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 2 && Number(productDetails?.bi_request?.IsExistingCustomer) === 2) {
        //       fgsyearlyOutputAmount = 0
        //     } else if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //       // fgstargetAmountForRemaindCount = fgstargetAmountForRemaindCount - 1
        //       fgsyearlyOutputAmount = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) - 1]?.PAYOUT_OF_ACCRU_OF_SB_8
        //       fgsExtralabel = `for ${productDetails?.bi_request?.PR_PPT} year +`
        //     }
        //     fgstotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fgsfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(fgstargetAmountForRemaindCount)} years + ₹ {Math.round(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1).toLocaleString('en-IN')} </span>
        //     break;
        //   default:
        //     break;
        // }

        // if (Number(productDetails?.bi_request?.Proposition) === 1) {
        //   fgstotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fgsoutputAmt).toLocaleString('en-IN')}</ins> After a period of {productDetails?.biResponseCompleteData?.length} years</span>
        // }

        // if (Number(productDetails?.bi_request?.AccrualPeriod)) {
        //   if (Number(productDetails?.bi_request?.AutoRenewalBooster) === 1 || Number(productDetails?.bi_request?.IsExistingCustomer) === 1) {
        //     fgsExtralabel = `for ${Number(productDetails?.bi_request?.PR_PPT) + fgsAcc_period}nd year + `
        //     fgsyearlyOutputAmount = productDetails?.biResponseCompleteData[Number(productDetails?.bi_request?.PR_PPT) + fgsAcc_period]?.PAYOUT_OF_ACCRU_OF_SB_8
        //   }
        //   let count = productDetails?.biResponseCompleteData.filter((items) => Number(Math.round(items.PAYOUT_OF_ACCRU_OF_SB_8)) === Number(Math.round(fgsfixIncome)))
        //   fgstotalOutputYearSuffixLabel = <span><ins className='font-weight-medium'>{Math.round(fgsfixIncome).toLocaleString('en-IN')}</ins> per annum for {Number(count?.length)} years + ₹ {Math.round(productDetails?.biResponseCompleteData[productDetails?.biResponseCompleteData.length - 1]?.TOTAL_MB_BS_1).toLocaleString('en-IN')} </span>
        // }

        outputAmt = fgsoutputAmt
        // ANN_PREM_YEARLY * ppt
        inputAmount = fgsinputAmount
        yearlyInputAmount = fgsyearlyInputAmount
        // yearlyOutputAmount = Math.round(fgsyearlyOutputAmount) > 0 ? Math.round(fgsyearlyOutputAmount) : 0;
        yearlyOutputAmount = ""
        inputStr = "per annum";
        // outputStr = Math.round(fgsyearlyOutputAmount) > 0 ? fgsExtralabel : "";
        outputStr = ""
        totalOutputYear = "";
        totalOutputYearSuffixLabel = fgstotalOutputYearSuffixLabel
        totalInputYear = productDetails?.bi_request?.PR_PPT;
        totalInputYearSuffixLabel = "years";
        belowOutputYearSuffixLabel = "Refer Cashflow Table for Details";
        break;

      default:
        break;
    }
  }
  return {
    inputAmount,
    inputStr,
    yearlyInputAmount,
    totalInputYear,
    totalInputYearSuffixLabel,
    outputAmt,
    totalOutputAmtSuffixLabel,
    yearlyOutputAmount,
    outputStr,
    totalOutputYear,
    totalOutputYearSuffixLabel,
    belowOutputYearSuffixLabel,
    additionalOutputAmt,
    outputNote,
    yearlyOutputAmountBold,
    showPayoutPeriodMsg,
    payoutPeriodMsg,
    onlyShowBelowOutputYearSuffixLabel,
    startingOutPutLabel

  };
}

function getFormatedData(input_mode) {
  let frequency = "";
  switch (input_mode) {
    case "1":
      frequency = "per annum";
      break;
    case "2":
      frequency = "half yearly";

      break;
    case "3":
      frequency = "per quarter";

      break;
    case "4":
      frequency = "per month";

      break;
    case "5":
      frequency = "one time";

      break;

    default:
      break;
  }

  return frequency;
}

export { calculate_input_values, fetchYouPayYouGetPrice };
